module.exports = __webpack_public_path__ + "img/hendrik-ido-ambacht-logo.7079df12.png";